<template>
    <div class="w-full">
        <div v-if="view === 'edit'">
            <div class="w-full mb-4">
                <div class="text-xl mb-2"><strong>Content</strong></div>
                <w-editor :content="form.content" v-model="form.content" height="24rem"> </w-editor>
            </div>
            <div class="w-full mt-8">
                <button @click="preview" class="btn btn-yellow">Preview</button>
                <a href="/admin" class="text-black ml-2 btn btn-default">Cancel</a>
            </div>
        </div>

        <div v-if="view === 'preview'">
            <div class="flex flex-wrap items-center justify-center mb-6">
                <button @click="view = 'edit'" class="btn btn-blue mx-6">Edit</button>
                <button @click="handlePublish" class="btn btn-yellow mx-6">Publish</button>
            </div>

            <div v-html="htmlPreview"></div>

            <div class="flex flex-wrap items-center justify-center mt-6">
                <button @click="view = 'edit'" class="btn btn-blue mx-6">Edit</button>
                <button @click="handlePublish" class="btn btn-yellow mx-6">Publish</button>
            </div>
        </div>

        <flash-message seconds-to-display="5" ref="flash"></flash-message>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const props = defineProps({
    publishRoute: String,
    previewRoute: String
});

const flash = ref(null);
const view = ref('edit');
const form = ref({ content: '' });
const error = ref(null);
const published = ref(false);
const htmlPreview = ref('');

function preview() {
    axios.post(props.previewRoute, form.value)
        .then(response => {
            htmlPreview.value = response.data.html;
            view.value = 'preview';
        }).catch(err => {
            error.value = err.errors || 'Error';
        });
}

function handlePublish() {
    axios.post(props.publishRoute, form.value)
        .then(response => {
            view.value = 'edit';
            form.value.content = '';
            flash.value.display('Succesfully queued message');
        }).catch(err => {
            flash.value.error('Error queueing message', err.message || '');
        });
}
</script>
